import WPAPISearchService from "../../wp-rest/search";

const { useState, useEffect } = wp.element;

function SearchResultsComponent(props) {
  let searchTermSlug = props.searchTermSlug;
  let postsURL = "/wp-json/wp/v2/channel?_embed&per_page=30&" + "&search=" + searchTermSlug;
  const searchResults = WPAPISearchService(postsURL);

  function getChannelPackage(categoryArray) {
    let lowestCategoryArray = [];
    categoryArray.forEach((item, index) => {
      lowestCategoryArray.push(item.name);
    });
    return lowestCategoryArray.join(", ");
  }

  function returnResults(searchResults) {
    if(searchResults[0] && searchResults[0].length > 0) {
      return searchResults[0] &&
        searchResults[0].map((searchResult, index) => (
          <div className="single-channel-result" key={index}>
            <p>
              Found <span dangerouslySetInnerHTML={{ __html: searchResult.title.rendered }}></span>{" "}
              (Ch {searchResult.acf.channel_number}) in the following package(s) -{" "}
              {getChannelPackage(searchResult._embedded["wp:term"][0])}
            </p>
          </div>
        ))
    } else {
      return "No results found. Please try another search."
    }
  }
  return (
    <div className="search-results-wrapper">
      {returnResults(searchResults)}
    </div>
  );
}

export default SearchResultsComponent;



// WEBPACK FOOTER //
// ./react/components/search/search-results-component.jsx